import {Space} from 'antd';
import styled from 'styled-components';

const StyledVendorSubscriptions = styled(Space)`
  width: 100%;
`;


export {
  StyledVendorSubscriptions,
}